<template>

  <b-modal 
    ref="modal"
    v-model="visible"
    :title="title"
    size="lg"
    @hide="hide"
    hideFooter
  > 
    <div v-if="alertExists">
      <dl>     
        <dt 
          class="contenido"
          v-for="(sensor, index) in sensorList"
          v-bind:key="index"
          v-bind:value="sensor">
            {{ sensor.description }} ({{ sensor.group }})
        </dt>
      </dl>
    </div>

    <div v-else>
      <span>No existen sensores con alarmas activas actualmente</span>
    </div>
  </b-modal>
  
</template>

<script>
import GroupService from "@/services/GroupService";

export default {
  name: "modal",
  components: {},
  props: ["title", "location"],
  data() {
    return {
      visible: false,
      alertExists: false,
      sensorList: []
    };
  },
  methods: {
    
    show(){ 
      this.visible = true;
      this.retrieveAlertInfo();
    },

    hide(){
      this.visible = false;
      this.$emit('onHide');
    },

    retrieveAlertInfo() {
      this.sensorList = [];

      GroupService.getAlertSensorsFromLocation(this.location._id)
      .then(response => {
        if (!response.data || response.data.length <= 0) {
          this.alertExists = false;
        } else {
          this.alertExists = true;
          this.sensorList = response.data;
        }
      })
      .catch(err => {
        console.log("Error recuperando listado de sensores con alarmas")
        console.log(err)
      })
    }
  }
};
</script>

<style scoped>
.contenido{
    font-weight: normal;
}
.contenido:hover{
    color:rgb(255, 102, 0);
    font-weight:normal;
}
</style>
